/*! Cardio Online — finder + blog + click-id tracking layer v1.1.0
    Fires GA4 events and captures cart attributes for attribution.
    No external deps. Uses gtag injected by Shopify Google channel.

    v1.1.0 (2026-07-17): capture Google Ads click ids (gclid/gbraid/wbraid) from the
    landing URL and carry them to order.note_attributes via cart attributes.
    WHY: auto-tagging puts the click id in the URL, but nothing persisted it to the
    order, so there was no order<->click key. That blocks POAS (profit-as-conversion-
    value), which uploads gross profit against the click that earned it.
    See Cardio-Online-brain/Ops/poas-implementation-spec.md §3.1 / §6.1. */
(function () {
  'use strict';
  if (window.__COTrackingLoaded) return;
  window.__COTrackingLoaded = true;

  // ---------- gtag / dataLayer push ----------
  var dl = window.dataLayer = window.dataLayer || [];
  function track(eventName, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params || {});
      }
      dl.push(Object.assign({ event: eventName }, params || {}));
    } catch (e) { /* silent */ }
  }

  // ---------- attribution persistence ----------
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  // Google Ads click ids get their own, longer TTL: the conversion action's
  // click-through lookback is 90 days, and this store sells high-AOV considered
  // purchases with long paths. A 30d TTL would silently drop conversions that are
  // still inside Google's window.
  var CLICK_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var CLICK_KEYS = []; // 2026-07-24: click-id cart-stamping disabled — POAS Option A keys on the order id, so gclid/gbraid are no longer written to order note attributes.
  function ttlFor(k) { return CLICK_KEYS.indexOf(k) > -1 ? CLICK_TTL_MS : TTL_MS; }
  function setAttr(k, v) {
    try { localStorage.setItem('co_attr_' + k, JSON.stringify({ v: v, t: Date.now() })); } catch (e) {}
  }
  function getAttr(k) {
    try {
      var raw = localStorage.getItem('co_attr_' + k);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (Date.now() - o.t > ttlFor(k)) { localStorage.removeItem('co_attr_' + k); return null; }
      return o.v;
    } catch (e) { return null; }
  }

  // ---------- capture ?finder=, ?ref= and Google Ads click ids from URL ----------
  var sawClickId = false;
  (function captureFromUrl() {
    try {
      var p = new URLSearchParams(window.location.search);
      var f = p.get('finder');
      var r = p.get('ref');
      if (f) setAttr('finder', f);
      if (r) setAttr('ref', r);
      // Last paid click wins, which is what we want to upload the conversion against.
      CLICK_KEYS.forEach(function (k) {
        var v = p.get(k);
        if (v) { setAttr(k, v); sawClickId = true; }
      });
    } catch (e) {}
  })();

  // ---------- attach attributes to cart on add ----------
  function applyCartAttributes() {
    var attrs = {};
    var f = getAttr('finder');
    var r = getAttr('ref');
    if (f) attrs.finder_source = f;
    if (r) attrs.blog_source = r;
    CLICK_KEYS.forEach(function (k) {
      var v = getAttr(k);
      if (v) attrs[k] = v;
    });
    if (!Object.keys(attrs).length) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      credentials: 'same-origin'
    }).catch(function () {});
  }

  // Stamp the click id onto the cart at landing, not only on add-to-cart. Cart
  // attributes persist on the cart independently of line items, so doing it now means
  // the id survives paths that never hit /cart/add (e.g. dynamic "Buy it now").
  // Only fires when a click id was actually in the URL, i.e. once per ad click.
  if (sawClickId) {
    try { applyCartAttributes(); } catch (e) {}
  }

  // patch fetch
  if (window.fetch && !window.__COFetchPatched) {
    window.__COFetchPatched = true;
    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch(input, init);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function () { applyCartAttributes(); }).catch(function () {});
      }
      return p;
    };
  }

  // patch XMLHttpRequest (legacy ajax carts)
  if (window.XMLHttpRequest && !window.__COXhrPatched) {
    window.__COXhrPatched = true;
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__co_url = u; return origOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (/\/cart\/add(\.js)?(\?|$)/.test(String(xhr.__co_url || ''))) {
        xhr.addEventListener('load', function () { applyCartAttributes(); });
      }
      return origSend.apply(this, arguments);
    };
  }

  // non-ajax form fallback
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || !/\/cart\/add($|\?)/.test(f.action)) return;
    try {
      var attrs = {};
      var fin = getAttr('finder'), ref = getAttr('ref');
      if (fin) attrs['attributes[finder_source]'] = fin;
      if (ref) attrs['attributes[blog_source]'] = ref;
      CLICK_KEYS.forEach(function (k) {
        var v = getAttr(k);
        if (v) attrs['attributes[' + k + ']'] = v;
      });
      if (!Object.keys(attrs).length) return;
      var fd = new FormData();
      Object.keys(attrs).forEach(function (k) { fd.append(k, attrs[k]); });
      if (navigator.sendBeacon) navigator.sendBeacon('/cart/update.js', fd);
    } catch (err) {}
  }, true);

  // ---------- blog product-link click tracking ----------
  function inBlogContext() {
    return !!(window.CO_BLOG_CONTEXT && window.CO_BLOG_CONTEXT.article_handle);
  }

  document.addEventListener('click', function (e) {
    if (!inBlogContext()) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    if (!a.closest('.article-main, [data-article-body]')) return;
    var href = a.getAttribute('href') || '';
    if (!/\/products\//.test(href)) return;
    var slug = window.CO_BLOG_CONTEXT.article_handle;
    var title = window.CO_BLOG_CONTEXT.article_title;
    var productHandle = (href.match(/\/products\/([^\/?#]+)/) || [])[1] || null;
    var position = a.getAttribute('data-cta-position') || null;
    try {
      var url = new URL(a.href, window.location.origin);
      if (!url.searchParams.has('ref')) {
        url.searchParams.set('ref', 'blog_' + slug);
        a.href = url.toString();
      }
    } catch (err) {}
    setAttr('ref', 'blog_' + slug);
    track('blog_product_click', {
      blog_slug: slug,
      blog_title: title,
      product_handle: productHandle,
      cta_position: position,
      link_text: (a.textContent || '').trim().slice(0, 100)
    });
  }, true);

  // ---------- finder tracking (auto-initialised on finder pages) ----------
  function initFinder() {
    var FINDER = window.CO_FINDER_NAME;
    if (!FINDER) return;
    var ROOT = document.querySelector('.fmt-app, .feb-app, .fct-app, [data-co-finder]');
    if (!ROOT) {
      // try once more after DOM settles
      setTimeout(function () {
        ROOT = document.querySelector('.fmt-app, .feb-app, .fct-app, [data-co-finder]');
        if (ROOT) attachFinder(FINDER, ROOT);
      }, 500);
      return;
    }
    attachFinder(FINDER, ROOT);
  }

  function attachFinder(FINDER, ROOT) {
    var fired = { start: false, results: false, email: false };
    var stepCount = 0;

    function fireStart() {
      if (fired.start) return;
      fired.start = true;
      track('finder_start', { finder_name: FINDER });
    }

    ROOT.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-val]');
      if (!b) return;
      fireStart();
      stepCount++;
      var group = b.closest('[data-group]');
      track('finder_step', {
        finder_name: FINDER,
        step_number: stepCount,
        group: group ? group.getAttribute('data-group') : null,
        answer: b.getAttribute('data-val') || (b.textContent || '').trim().slice(0, 40)
      });
    });

    // slider interactions (.fmt-slider / .feb-slider / .fct-slider)
    ROOT.addEventListener('input', function (e) {
      var slider = e.target && e.target.closest && e.target.closest('.fmt-slider, .feb-slider, .fct-slider, [data-co-slider]');
      if (!slider) return;
      fireStart();
    });

    // see-results click
    var seeBtn = ROOT.querySelector('#see-results, [data-co-see-results]');
    if (seeBtn) {
      seeBtn.addEventListener('click', function () {
        if (fired.results) return;
        fired.results = true;
        setTimeout(function () {
          var grid = ROOT.querySelector('#result-grid, [data-co-result-grid]');
          var n = grid ? grid.querySelectorAll('.p-cta, a[data-co-product-link]').length : 0;
          track('finder_view_results', { finder_name: FINDER, results_count: n });
        }, 150);
      });
    }

    // email-form submit
    var emailForm = ROOT.querySelector('#email-form, [data-co-email-form]');
    if (emailForm) {
      emailForm.addEventListener('submit', function () {
        if (fired.email) return;
        fired.email = true;
        track('finder_email_capture', { finder_name: FINDER });
      });
    }

    // delegated product-link clicks within finder results
    ROOT.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.p-cta, a[data-co-product-link]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var productHandle = (href.match(/\/products\/([^\/?#]+)/) || [])[1] || null;
      var card = a.closest('.p-card, [data-co-product]');
      var position = null;
      if (card && card.parentNode) {
        position = Array.prototype.indexOf.call(card.parentNode.children, card) + 1;
      }
      try {
        var url = new URL(a.href, window.location.origin);
        if (!url.searchParams.has('finder')) {
          url.searchParams.set('finder', FINDER);
          a.href = url.toString();
        }
      } catch (err) {}
      setAttr('finder', FINDER);
      track('finder_recommendation_click', {
        finder_name: FINDER,
        product_handle: productHandle,
        position: position
      });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFinder);
  } else {
    initFinder();
  }

  // ---------- public API ----------
  window.CO = window.CO || {};
  window.CO.track = track;
  window.CO.setAttribution = function (key, val) { if (key && val) setAttr(key, val); };
  window.CO.getAttribution = function () { return { finder: getAttr('finder'), ref: getAttr('ref') }; };
})();
